export default __webpack_public_path__ + "static/media/view all icon.a90135cd.png";